export const environment = {
  firebase: {
    apiKey: "AIzaSyBKAJugddjpZvxwnzIVrgqYP-i_th5umgk",
    authDomain: "noname-459cb.firebaseapp.com",
    databaseURL: "https://noname-459cb.firebaseio.com",
    projectId: "noname-459cb",
    storageBucket: "noname-459cb.firebasestorage.app",
    messagingSenderId: "795449313701",
    appId: "1:795449313701:web:b794b04f38a0a3a4c4c04c",
    measurementId: "G-5TB2BRSB1Y"
  },
  configFetchIntervalMillis: 10 * 1000,
};
